module.exports = __webpack_public_path__ + "img/Lido.835760a5.svg";